/**
 * Sélecteur de langue du parcours de signature — repris de la version du client.
 *
 * Il ne s'affiche que là où il sert : le parcours installateur. Le reste de
 * l'application reste en français, parce que ses utilisateurs le sont.
 */
import { useState, useRef, useEffect } from 'react';
import { Languages, Check } from 'lucide-react';
import { LANGUAGES } from '@/shared/i18n/cftsign';
import Drapeau from '@/shared/i18n/Drapeaux';

export default function LanguageSwitcher({ lang, onChange, dark = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const btnCls = dark
    ? 'text-white/70 hover:text-white'
    : 'text-neutral-600 hover:text-neutral-900';

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className={`text-[12px] flex items-center gap-1 min-h-11 md:min-h-0 ${btnCls}`}
        aria-label="Language"
        data-testid="lang-switcher-btn"
      >
        <Languages className="w-3.5 h-3.5" />
        <Drapeau code={current.code} titre={current.label} />
        <span>{current.code.toUpperCase()}</span>
      </button>
      {open && (
        <div
          className="absolute right-0 top-full mt-1 bg-white rounded-md shadow-lg border border-neutral-200 py-1 min-w-[150px] z-50"
          data-testid="lang-switcher-menu"
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => { onChange(l.code); setOpen(false); }}
              className={`w-full text-left px-3 py-1.5 text-[12px] flex items-center justify-between gap-2 hover:bg-neutral-50 ${
                l.code === lang ? 'text-neutral-900 font-medium bg-neutral-50/50' : 'text-neutral-700'
              }`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="flex items-center gap-2">
                <Drapeau code={l.code} />
                <span>{l.label}</span>
              </span>
              {l.code === lang && <Check className="w-3.5 h-3.5 text-emerald-600" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
